import { Typography } from '@mui/material'
import { useCountDown } from 'ahooks'
import dayjs, { unix } from 'dayjs'
import React from 'react'

const Countdown = ({ unlockTimestamp, onEnd }: { unlockTimestamp: number; onEnd: () => void }) => {
  const [, formattedRes] = useCountDown({
    targetDate: unix(unlockTimestamp).isAfter(dayjs()) ? unlockTimestamp * 1000 : undefined,
    onEnd,
  })

  const { days, hours, minutes, seconds } = formattedRes

  return (
    <Typography sx={{ mt: 'auto' }}>
      Lock until
      <Typography component="span" color="#BFFF0B">
        &nbsp;{days} d {hours} h {minutes} m {seconds} s&nbsp;
      </Typography>
      later
    </Typography>
  )
}

export default Countdown
